import { isAfter } from 'date-fns'

import { parseListingFormDate } from '../../../../../RentalPortal.utils'

export function getListingPublicationScheduleFieldLimits({
  bounds,
  date,
  maxDate,
  timezone,
}) {
  const after = parseListingFormDate(bounds.after, timezone)

  return {
    maxValue: parseListingFormDate(bounds.before, timezone) ?? maxDate,
    minValue: after && isAfter(after, date) ? after : date,
  }
}
